<template>
  <v-container fluid grid-list-lg>
    <v-layout rows wrap>
      <v-flex xs12 sm6 lg4 order-xs3 order-sm1 order-lg1>
        <v-layout row wrap>
          <v-flex>
            <v-card>
              <v-card-title class="profile-header">
                <h3>Profile</h3>
                <v-btn color="primary" v-if="!otpEnabled && environment === 'development' && hasPermission('superuser')" @click="enableOTP">Enable 2FA</v-btn>
                <v-btn color="primary" v-if="otpEnabled" @click="disableOTP">Disable 2FA</v-btn>
              </v-card-title>
              <v-card-text>
                <table class="centered">
                  <tbody>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Connected:</th>
                      <td>{{this.connected}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Name:</th>
                      <td>{{myProfile.name}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Email:</th>
                      <td>{{myProfile.email}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Timezone:</th>
                      <td>{{myProfile.timezone}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Position:</th>
                      <td>{{myProfile.position}}</td>
                    </tr>
                    <tr v-if="!(terminalsCardCanCharge.length > 1 || terminalsACHCanCharge.length > 1)">
                      <th text-xs-right class="primary--text table-align-right">Account:</th>
                      <td>{{accountNameSelected}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Created:</th>
                      <td>{{timeAgo(myProfile.created, true)}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Password Changed:</th>
                      <td>{{timeAgo(myProfile.password_last_changed, true)}}</td>
                    </tr>
                    <tr>
                      <th text-xs-right class="primary--text table-align-right">Password Expires:</th>
                      <td>{{timeAgo(myProfile.password_last_changed, true)}}</td>
                    </tr>
                    <tr v-if="terminalsCardCanCharge.length > 1">
                      <th text-xs-right class="primary--text">Default Card Terminal</th>
                      <td>
                        <v-autocomplete
                          v-model="defaultCardTerminalId"
                          :items="cardTerminalList"
                          item-text="name"
                          item-value="terminal_id"
                          @change="handleTerminalChange('card')"
                          :error-messages="error.card"
                          :loading="loading.card"
                          single-line
                          :success-messages="success.card"
                        />
                      </td>
                    </tr>
                    <tr v-if="terminalsACHCanCharge.length > 1">
                      <th text-xs-right class="primary--text">Default ACH Terminal</th>
                      <td>
                        <v-autocomplete
                          v-model="defaultAchTerminalId"
                          :items="achTerminalList"
                          item-text="name"
                          item-value="terminal_id"
                          @change="handleTerminalChange('ach')"
                          :error-messages="error.ach"
                          :loading="loading.ach"
                          single-line
                          :success-messages="success.ach"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-card-text>
              <v-card-actions class="pr-4 pb-3">
                <v-spacer></v-spacer>
                <v-btn color="primary" to="change_password">Change Password</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex v-if="accountList.length === 1">
            <v-card>
              <v-card-title><h3>Account</h3></v-card-title>
              <v-card-text>
                <div class="primary--text">{{accountSelected.name}}</div>

                <template v-if="accountSelected.logo">
                  <v-img contain max-height="100px" max-width="200px" position="left, center" :src="imageUrl + '/' + accountSelected.logo"/>
                </template>

                <div>{{accountSelected.street_1}}</div>
                <div>{{accountSelected.street_2}}</div>
                <div>
                  {{accountSelected.city}},
                  {{accountSelected.state}}
                  {{accountSelected.zip}}
                </div>
                <div v-if="hasPermission('can_manage_account')">
                  <v-text-field
                    label="Manager Password"
                    v-model="accountSelected.manager_password"
                    box
                    hide-details
                  />
                </div>
                <div v-if="hasPermission('can_manage_account')">
                  <v-text-field
                    label="Manager Password"
                    v-model="accountSelected.manager_password"
                    @keypress.enter="show"
                  >
                    <template v-slot:append>
                      <v-btn
                        depressed
                        tile
                        color="primary"
                        class="ma-0"
                        @click="show"
                      >
                        save
                      </v-btn>
                    </template>
                  </v-text-field>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 sm6 lg8 order-xs2 order-sm2 order-lg2 v-if="hasPermission('can_use_billings') || hasPermission('can_use_hpp') || hasPermission('can_waive_card_fees') || hasPermission('can_waive_health_card_fees') || hasAccountPermission('can_view_funding')">
        <v-layout row wrap>
          <v-flex xs12 lg6 v-if="hasPermission('can_use_billings') || hasPermission('can_waive_card_fees') || hasPermission('can_waive_health_card_fees') || hasAccountPermission('can_view_funding')">
            <v-card>
              <v-card-title><h3>Help</h3></v-card-title>
              <v-card-text>
                <v-btn color="primary" to="/credit?waive=1" v-if="hasPermission('can_waive_card_fees')">
                  For use with waive fee&nbsp;<b>ONLY</b>
                  <v-divider vertical class="ml-3 mr-2" v-if="hasPermission('has_inline_help')"></v-divider>
                  <Lightbulb color="primary--text">
                    <template v-slot:message>
                      <span>For Waiving the fee on a customer.</span>
                    </template>
                  </Lightbulb>
                </v-btn>

                <v-btn color="primary" to="/credit?waive=2" v-if="hasPermission('can_waive_health_card_fees')">
                  For Fixed Insurance Payment
                  <v-divider vertical class="ml-3 mr-2" v-if="hasPermission('has_inline_help')"></v-divider>
                  <Lightbulb color="primary--text">
                    <template v-slot:message>
                      <span>Used for fixed insurance payment cards.</span>
                    </template>
                  </Lightbulb>
                </v-btn>

                <v-btn color="primary" href="/static/settlement_report_example.png" target="_blank" v-if="environment === 'development' && hasPermission('has_inline_help')">Settlement Report Example</v-btn>

                <v-btn color="primary" to="/billings" v-if="hasPermission('can_use_billings')">
                  Billings
                  <v-divider vertical class="ml-3 mr-2" v-if="hasPermission('has_inline_help')"></v-divider>
                  <Lightbulb color="primary--text">
                    <template v-slot:message>
                      <span>Customer billings: billing info and tokens.</span>
                    </template>
                  </Lightbulb>
                </v-btn>

                <v-btn color="primary" to="/paynetworx/funding" v-if="hasAccountPermission('can_view_funding')">
                  Paynetworx Settlement & Funding Dashboard
                </v-btn>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 lg6 v-if="hasPermission('can_use_hpp')">
            <v-card>
              <v-card-title><h3>Links</h3></v-card-title>
              <v-card-text>
                <v-layout column>
                  <v-flex v-if="(environment === 'development' && accountSelected.account_id === 5) || accountSelected.account_id === 1507">
                    <h2 class="primary--text">HPP Links</h2>
                    <ul>
                      <li>
                        <a href="https://payments.paynetworx.com/?token=22eQ9O0xwSoUpsc0av9RLxnMfvm&amount=6000">$60 antibody test</a>
                      </li>
                      <li>
                        <a href="https://payments.paynetworx.com/?token=22eQ9O0xwSoUpsc0av9RLxnMfvm&amount=10000">$100 antigen test</a>
                      </li>
                      <li>
                        <a href="https://payments.paynetworx.com/?token=22eQ9O0xwSoUpsc0av9RLxnMfvm&amount=17500">$175 1 hour antigen test or 24 hour PCR</a>
                      </li>
                      <li>
                        <a href="https://payments.paynetworx.com/?token=22eQ9O0xwSoUpsc0av9RLxnMfvm&amount=25500">$255 eye drop</a>
                      </li>
                      <li>
                        <a href="https://payments.paynetworx.com/?token=22eQ9O0xwSoUpsc0av9RLxnMfvm&amount=30000">$300 3 hour PCR</a>
                      </li>
                    </ul>
                  </v-flex>

                  <v-flex>
                    <v-layout>
                      <v-flex>
                        <h2 class="primary--text">Hosted Payment Link</h2>
                      </v-flex>
                      <v-flex shrink>
                        <ExampleHPPLinkSite></ExampleHPPLinkSite>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-checkbox
                          v-if="showCheckbox"
                          v-model="useTwoTerminals"
                          color="primary"
                          label="Use Separate Terminals"
                        ></v-checkbox>
                        <v-autocomplete
                          v-if="!useTwoTerminals"
                          class="terminal-select"
                          v-model="tokenValues.selectedTerminalId"
                          :items="availableTerminals"
                          item-text="name"
                          item-value="id"
                          label="Terminal"
                        />
                        <v-autocomplete
                          v-if="useTwoTerminals && achTerminals.length"
                          class="double-terminal-select"
                          v-model="tokenValues.selectedACHTerminalId"
                          :items="achTerminals"
                          item-text="name"
                          item-value="id"
                          label="ACH Terminal"
                        />
                        <v-autocomplete
                          v-if="useTwoTerminals && cardTerminals.length"
                          class="double-terminal-select"
                          v-model="tokenValues.selectedCardTerminalId"
                          :items="cardTerminals"
                          item-text="name"
                          item-value="id"
                          label="Card Terminal"
                        />
                      </v-flex>

                      <v-flex xs12>
                        <v-divider class="my-2"></v-divider>
                        <v-checkbox
                          v-model="consentEnabled"
                          color="primary"
                          label="Require Terms & Conditions Consent"
                          hide-details
                          class="mt-0"
                        ></v-checkbox>
                      </v-flex>

                      <template v-if="consentEnabled">
                        <v-flex xs12>
                          <v-checkbox
                            v-model="consentRequired"
                            color="primary"
                            label="Block payment until consent is accepted"
                            hide-details
                            class="mt-0"
                          ></v-checkbox>
                        </v-flex>

                        <v-flex xs12>
                          <v-text-field
                            v-model="consentLabel"
                            label="Consent Checkbox Label (HTML allowed)"
                            placeholder="I agree to the Terms and Conditions of this payment."
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12>
                          <v-checkbox
                            v-model="consentModalEnabled"
                            color="primary"
                            label="Show Terms in a Modal Dialog"
                            hide-details
                            class="mt-0"
                          ></v-checkbox>
                        </v-flex>

                        <template v-if="consentModalEnabled">
                          <v-flex xs12>
                            <v-text-field
                              v-model="consentModalTitle"
                              label="Modal Title"
                              placeholder="Terms and Conditions"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12>
                            <v-textarea
                              v-model="consentModalContent"
                              label="Modal Content (HTML allowed)"
                              placeholder="<p>By proceeding with this payment...</p>"
                              rows="3"
                              auto-grow
                            ></v-textarea>
                          </v-flex>
                        </template>
                      </template>

                      <v-flex xs12 v-if="generatedUrl">
                        <span block class="generated-url">{{generatedUrl}}</span>
                      </v-flex>

                      <v-flex xs12 v-if="generatedUrlError">
                        <span block class="generated-url">{{generatedUrlError}}</span>
                      </v-flex>

                      <v-flex xs12 sm6>
                        <v-btn block :disabled="!!generatedUrl || !tokenValues.selectedTerminalId && !tokenValues.selectedACHTerminalId && !tokenValues.selectedCardTerminalId" color="primary" @click="getURL">Create Link</v-btn>
                      </v-flex>

                      <v-flex xs12 sm6>
                        <v-btn block :disabled="!generatedUrl" color="primary" @click="copyURL">Copy Link</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex v-if="(environment === 'development' && (accountSelected.account_id === 5 || accountSelected.account_id === 70 || accountSelected.account_id === 270)) || accountSelected.id === 12 || accountSelected.parent_account_id === 12">
                    <v-layout>
                      <v-flex>
                        <h2 class="primary--text">Invoice Link</h2>
                        <span v-if="(environment === 'development' && (accountSelected.account_id === 5 || accountSelected.account_id === 70 || accountSelected.account_id === 270)) || accountSelected.id === 12 || accountSelected.parent_account_id === 12">{{ accountSelected.parent_account_id }}</span>
                      </v-flex>
                      <v-flex shrink>
                        <ExampleInvoice></ExampleInvoice>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-checkbox
                          v-if="showCheckbox"
                          v-model="useTwoTerminals"
                          color="primary"
                          label="Use Separate Terminals"
                        ></v-checkbox>
                        <v-autocomplete
                          v-if="!useTwoTerminals"
                          class="terminal-select"
                          v-model="tokenValues.selectedTerminalId"
                          :items="availableTerminals"
                          item-text="name"
                          item-value="id"
                          label="Terminal"
                        />
                        <v-select
                          v-if="useTwoTerminals && achTerminals.length"
                          class="double-terminal-select"
                          v-model="tokenValues.selectedACHTerminalId"
                          :items="achTerminals"
                          item-text="name"
                          item-value="id"
                          label="ACH Terminal"
                        />
                        <v-select
                          v-if="useTwoTerminals && cardTerminals.length"
                          class="double-terminal-select"
                          v-model="tokenValues.selectedCardTerminalId"
                          :items="cardTerminals"
                          item-text="name"
                          item-value="id"
                          label="Card Terminal"
                        />
                      </v-flex>

                      <v-flex xs12 v-if="generatedUrl">
                        <span block class="generated-url">{{generatedUrl}}</span>
                      </v-flex>

                      <v-flex xs12 v-if="generatedUrlError">
                        <span block class="generated-url">{{generatedUrlError}}</span>
                      </v-flex>

                      <v-flex xs12 sm6>
                        <v-btn block :disabled="!!generatedUrl || !tokenValues.selectedTerminalId && !tokenValues.selectedACHTerminalId && !tokenValues.selectedCardTerminalId" color="primary" @click="getURL">Create Link</v-btn>
                      </v-flex>

                      <v-flex xs12 sm6>
                        <v-btn block :disabled="!generatedUrl" color="primary" @click="copyURL">Copy Link</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex v-if="otpEnabled">
        <v-card>
          <v-card-title><h3>2FA Type</h3></v-card-title>
          <v-card-text>
            <v-radio-group v-model="otpEnabled">
              <v-radio label="SMS" value="0"></v-radio>
              <v-radio label="TOTP" value="1"></v-radio>
              <v-radio label="Push" value="0"></v-radio>
            </v-radio-group>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 lg4 class="text-xs-center" v-if="qrValue">
        <v-card>
          <qrcode-vue :value="qrValue" size="300" className="qrcode"></qrcode-vue>
          <v-form>
            <v-card-title>
              <h3>2FA Token</h3>
            </v-card-title>
            <v-card-text class="text-xs-center xs12 sm6 offset-sm3">
              <v-text-field prepend-icon="lock" name="otpToken" label="2FA Token" v-model="otpToken"/>
            </v-card-text>
            <v-card-actions>
              <v-btn primary large block @click="verifyOTP">Validate</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>

      <template v-if="environment === 'development' && hasPermission('superuser')">
        <v-flex xs12 sm6 lg4>
          <v-card>
            <v-card-title><h3>Permissions</h3></v-card-title>
            <v-card-text>
              <div>
                <vue-json-pretty :data="permissions"></vue-json-pretty>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 sm6 lg4>
          <v-card>
            <v-card-title><h3>Settings</h3></v-card-title>
            <v-card-text>
              <div>
                <vue-json-pretty :data="myProfile.custom"></vue-json-pretty>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </template>

    </v-layout>

    <v-snackbar bottom centered color="success" v-model="isLinkCopied">
      <v-layout row wrap align-center>
        <v-flex>
          <v-icon>fa-info-circle</v-icon>
        </v-flex>
        <v-flex subheading>
          Link copied to clipboard
        </v-flex>
      </v-layout>
    </v-snackbar>
  </v-container>
</template>

<script>
import ExampleHPPLinkSite from '@/components/help/ExampleHPPLinkSiteDialog'
import ExampleInvoice from '@/components/help/ExampleInvoiceDialog'
import Lightbulb from '@/components/help/Lightbulb'
import QrcodeVue from 'qrcode.vue'
import VueJsonPretty from '@/components/VueJsonPrettyWrapper'

import APIMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

export default {
  components: {
    ExampleHPPLinkSite,
    ExampleInvoice,
    Lightbulb,
    QrcodeVue,
    VueJsonPretty
  },

  mixins: [
    APIMixin,
    AuthMixin,
    DisplayMixin,
    StoreMixin
  ],

  data: function () {
    return {
      loading: {
        'card': false,
        'ach': false
      },
      success: {
        'card': [],
        'ach': []
      },
      error: {
        'card': [],
        'ach': []
      },
      imageUrl: process.env.VUE_APP_IMAGE_URL,
      qrValue: false,
      otpEnabled: false,
      otpType: false,
      otpToken: '',
      availableTerminals: null,
      achTerminals: null,
      cardTerminals: null,
      useTwoTerminals: false,
      showCheckbox: false,
      consentEnabled: false,
      consentRequired: false,
      consentLabel: '',
      consentModalEnabled: false,
      consentModalTitle: '',
      consentModalContent: '',
      tokenValues: {
        amount: undefined,
        method: undefined,
        name: undefined,
        billingName: undefined,
        email: undefined,
        phone: undefined,
        address1: undefined,
        address2: undefined,
        city: undefined,
        state: undefined,
        zip: undefined,
        customField1: undefined,
        customField2: undefined,
        customField3: undefined,
        selectedTerminalId: null
      },
      generatedUrl: '',
      generatedUrlError: '',
      isLinkCopied: false,
      managerPassword: '',
      cardTerminalsList: [{name: '- None -', terminal_id: 0}],
      achTerminalsList: [{name: '- None -', terminal_id: 0}],
      defaultCardTerminalId: null,
      defaultAchTerminalId: null,
      terminal: {},
      account: {}
    }
  },

  async mounted () {
    if (this.myProfile.custom.hasOwnProperty('default_card_terminal_id')) {
      this.defaultCardTerminalId = this.myProfile.custom.default_card_terminal_id
    }
    if (this.myProfile.custom.hasOwnProperty('default_ach_terminal_id')) {
      this.defaultAchTerminalId = this.myProfile.custom.default_ach_terminal_id
    }

    const terminalArr = [...this.terminalsACHCanCharge, ...this.terminalsCardCanCharge]
    this.availableTerminals = terminalArr.filter((v, i, a) => a.findIndex(t => (t.code === v.code)) === i)
    if (this.availableTerminals.length === 1) {
      this.tokenValues.selectedTerminalId = this.availableTerminals[this.availableTerminals.length - 1].id
    }
    this.bothTerminals = this.availableTerminals.filter(terminal => {
      if (terminal.type[0] === '[') {
        return JSON.parse(terminal.type).some(item => item === 'ach') && JSON.parse(terminal.type).some(item => item !== 'ach')
      } else {
        return false
      }
    })
    this.achTerminals = [...this.availableTerminals.filter(terminal => {
      if (terminal.type === 'ach') {
        return true
      } else if (terminal.type[0] === '[') {
        return !JSON.parse(terminal.type).some(item => item !== 'ach')
      } else return false
    }), ...this.bothTerminals]
    this.cardTerminals = [...this.availableTerminals.filter(terminal => {
      if (terminal.type[0] === '[') {
        return !JSON.parse(terminal.type).some(item => item === 'ach')
      } else {
        return terminal.type !== 'ach'
      }
    }), ...this.bothTerminals]
    if (!this.bothTerminals.length) {
      this.useTwoTerminals = true
    } else if ((this.achTerminals.length - this.bothTerminals.length) > 0 || (this.cardTerminals.length - this.bothTerminals.length) > 0) {
      this.showCheckbox = true
    }
    if (this.bothTerminals.length === 1 && !this.useTwoTerminals) {
      this.tokenValues.selectedTerminalId = this.bothTerminals[0].id
    }

    await this.getURL()
  },

  watch: {
    consentEnabled () {
      this.generatedUrl = ''
    },
    consentRequired () {
      this.generatedUrl = ''
    },
    consentLabel () {
      this.generatedUrl = ''
    },
    consentModalEnabled () {
      this.generatedUrl = ''
    },
    consentModalTitle () {
      this.generatedUrl = ''
    },
    consentModalContent () {
      this.generatedUrl = ''
    }
  },

  computed: {
    environment () {
      return process.env.NODE_ENV
    },
    cardTerminalList: function () {
      let terminals = [
        {terminal_id: 0, name: '- None -'}
      ]
      return terminals.concat(this.terminalsCardCanCharge)
    },
    achTerminalList: function () {
      let terminals = [
        {terminal_id: 0, name: '- None -'}
      ]
      return terminals.concat(this.terminalsACHCanCharge)
    }
  },

  methods: {
    waiveFeeRedirect (to, event) {
      let message = `Attention:
Clicking on this link will allow you to process a Government issued Pre-Paid Card or an Insurance Issued Pre-Paid Card where the amount is set on the card for an Individual or group of patients. This does not include FSA, HSA or any standard Debit, Credit or Savings Card. Are you sure you would like to proceed with the transaction?`

      if (confirm(message)) {
        this.$router.push(to)
      }
    },

    async enableOTP () {
      this.otpEnabled = true

      try {
        let result = await this.api({
          method: 'get',
          url: `/users/otp`
        })

        this.qrValue = result.data.secret.otpauth_url
      } catch (err) {
        console.log(err)
      }
    },

    async disableOTP () {
      try {
        await this.api({
          method: 'delete',
          url: `/users/otp`
        })

        this.otpEnabled = false
        this.otpType = false
      } catch (err) {
        console.log(err)
      }
    },

    async verifyOTP () {
      try {
        let result = await this.api({
          method: 'post',
          url: `/users/otp`,
          data: { otp_token: this.otpToken }
        })

        console.log('verityOTP result')
        console.log(result)
        this.otpEnabled = true
        this.otpType = 1
      } catch (err) {
        console.log(err)
      }
    },

    async handleTerminalChange (terminalType) {
      try {
        this.loading[terminalType] = true

        let options = {}

        if (terminalType === 'card') {
          options['default_card_terminal_id'] = this.defaultCardTerminalId
        }

        if (terminalType === 'ach') {
          options['default_ach_terminal_id'] = this.defaultAchTerminalId
        }

        if (Object.keys(options).length) {
          let result = await this.api({
            method: 'put',
            url: '/users/' + this.myProfile.email,
            data: { custom: options }
          })

          if (result.data.hasOwnProperty('error') && !result.data.error) {
            // update state
            if (terminalType === 'card' && options.hasOwnProperty('default_card_terminal_id')) {
              this.$store.commit('setDefaultCardTerminal', this.defaultCardTerminalId)
              this.success['card'] = ['Saved']
              setTimeout(() => {
                this.success['card'] = []
              }, '5000')
            }
            if (terminalType === 'ach' && options.hasOwnProperty('default_ach_terminal_id')) {
              this.$store.commit('setDefaultAchTerminal', this.defaultAchTerminalId)
              this.success['ach'] = ['Saved']
              setTimeout(() => {
                this.success['ach'] = []
              }, '5000')
            }
          } else {
            if (terminalType === 'card') {
              this.error['card'] = ['Problem Saving']
              setTimeout(() => {
                this.error['card'] = []
              }, '5000')
            }
            if (terminalType === 'ach') {
              this.error['ach'] = ['Problem Saving']
              setTimeout(() => {
                this.error['ach'] = []
              }, '5000')
            }
            throw new Error('Problem saving user')
          }
        }
      } catch (error) {
      } finally {
        this.loading[terminalType] = false
      }
    },

    copyURL () {
      if (this.generatedUrl && navigator && navigator.clipboard && navigator.clipboard.writeText) {
        this.isLinkCopied = true
        return navigator.clipboard.writeText(this.generatedUrl)
      }
    },

    hasAccountPermission (permission) {
      if (!this.myProfile || !this.myProfile.accounts) {
        return false
      }
      return this.myProfile.accounts.some(account => {
        return account.user_permissions && account.user_permissions[permission]
      })
    },

    async getURL () {
      this.generatedUrl = ''
      this.generatedUrlError = ''

      if (this.availableTerminals.length === 1) {
        this.tokenValues.selectedTerminalId = this.availableTerminals[0].id
      }

      if (this.tokenValues.selectedTerminalId || this.tokenValues.selectedCardTerminalId || this.tokenValues.selectedACHTerminalId) {
        try {
          let tokenData = {
            accountId: this.accountSelected.account_id,
            ...this.tokenValues,
            terminalId: !this.useTwoTerminals
              ? this.tokenValues.selectedTerminalId
              : { ach: this.tokenValues.selectedACHTerminalId, card: this.tokenValues.selectedCardTerminalId }
          }

          if (this.consentEnabled) {
            tokenData.custom = {
              consent: {
                enabled: true,
                required: this.consentRequired,
                label: this.consentLabel || 'I agree to the Terms and Conditions of this payment.'
              }
            }
            if (this.consentModalEnabled) {
              tokenData.custom.consent.modal = {
                enabled: true,
                title: this.consentModalTitle || 'Terms and Conditions',
                content: this.consentModalContent || ''
              }
            }
          }

          let { data } = await this.api({
            method: 'post',
            url: `/hosted_payment/tokenize`,
            data: tokenData
          })

          if (!data.error) {
            this.generatedUrl = `https://payments${process.env.NODE_ENV === 'development' ? '-dev' : window.location.hostname.includes('-qa.') ? '-qa' : ''}.paynetworx.com?token=${data.token}`
          } else {
            console.log(data)
            this.generatedUrlError = 'An error has occurred. Please relog and try again.'
          }
        } catch (err) {
          this.generatedUrlError = 'An error has occurred. Please relog and try again.'

          console.error(err)
        }
      } else {
        this.generatedUrlError = 'Please make sure you have selected terminals to process ACH and card transactions.'
      }
    }
  }
}
</script>
<style>
.v-input.terminal-select {
  height: 50px;
}
.v-input.double-terminal-select {
  height: 60px;
  font-size: 14px;
}
.v-card__title {
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
}
.v-btn--outline {
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.26);
}
.table-align-right {
  text-align: right;
  padding-right: 24px;
}
.profile-header {
  display: grid;
  grid-template-columns: 1fr auto
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue